import SocialIcon from './social-icon';

export default SocialIcon;
